import {Component, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {UserService} from '@services/user.service';
import {AuthenticationService} from '@services/authentification.service';
import {InvestPreneurComponent} from '@components/popup/invest-preneur/invest-preneur.component';
import {ActivatedRoute, Router} from '@angular/router';
import {FormComponent} from '@components/popup/form/form.component';
import {OnboardingService} from '@services/onboarding.service';
import {User} from '@models/user';
import {AdService} from '@services/ad.service';
import {NewsComponent} from '@components/popup/news/news.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {RateComponent} from '@components/popup/rate/rate.component';
import {CalendlyComponent} from '@components/popup/calendly/calendly.component';
import {LeducationFinanciereComponent} from '@components/popup/leducation-financiere/leducation-financiere.component';
import {PolygoneComponent} from '@components/popup/polygone/polygone.component';
import {TrackingService} from '@services/tracking.service';
import {AFFILIATE, Partner, Video} from '@models/partner';
import {CookieService} from 'ngx-cookie-service';
import {PurpleComponent} from '@components/popup/purple/purple.component';
import {IncreaseTrialComponent} from '@components/popup/increase-trial/increase-trial.component';
import {ShowPromoComponent} from '@components/popup/show-promo/show-promo.component';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {VideoComponent} from '@components/popup/video/video.component';
import {EndtrialComponent} from '@components/popup/endtrial/endtrial.component';
import {PubOpenComponent} from '@module/search/popup/pub-open/pub-open.component';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

    sidenavOpen = true;
    user: User;

    isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
        .pipe(
            map(result => result.matches)
        );

    // You can use @ViewChild() to get a reference to the component instance from a template variable: <mat-sidenav #sidenav>
    @ViewChild('sidenav', {static: true}) nav;

    showHeader = false;

    constructor(
        private breakpointObserver: BreakpointObserver,
        private dialog: MatDialog,
        private router: Router,
        private userService: UserService,
        private adService: AdService,
        public trackingService: TrackingService,
        public authenticationService: AuthenticationService,
        private deviceService: DeviceDetectorService,
        private route: ActivatedRoute,
        private cookieService: CookieService,
        public onboardingService: OnboardingService,
        private http: HttpClient
    ) {
        this.isHandset$.subscribe(result => {
            this.sidenavOpen = result;
        });
    }

    ngOnInit() {
        this.openForm();
        this.user = this.authenticationService.currentUser;
        this.showHeader = this.authenticationService.showHeader();

        this.route.queryParams
            .subscribe(params => {
                    if (params.partner !== undefined) {
                        for (var i = 0; i < AFFILIATE.length; i++) {
                            if (AFFILIATE[i].code.toLowerCase() === params.partner) {
                                this.cookieService.set('affiliate-code', params.partner, 7, '/');
                            }
                        }
                    }
                }
            );
    }

    openForm() {
        if (this.authenticationService.isLogin) {
            let startDate = new Date(this.authenticationService.currentUser.created_at).getTime();
            let days = (new Date().getTime() - startDate) / 86400000;
            if (!this.router.url.includes('/app/user/plan') &&
                this.authenticationService.currentUser.code_parrainage === 'INVEST_PRENEUR' &&
                this.authenticationService.currentUser.user_onboarding.show_pro_popup == true &&
                (this.authenticationService.currentUser.plan === '' || this.authenticationService.currentUser.plan === 'trial')) {
                const dialogRef = this.dialog.open(InvestPreneurComponent, {
                    width: '600px',
                    height: '500px',
                    disableClose: true,
                    data: {},
                });

                dialogRef.afterClosed().subscribe(result => {
                    this.authenticationService.currentUser.user_onboarding.show_pro_popup = false;
                    this.userService.updateOnboarding(this.authenticationService.currentUser);
                });
            } else if (!this.router.url.includes('/app/user/plan') &&
                this.authenticationService.currentUser.code_parrainage === 'LEDUCATION_FINANCIERE' &&
                this.authenticationService.currentUser.user_onboarding.show_pro_popup == true &&
                (this.authenticationService.currentUser.plan === '' || this.authenticationService.currentUser.plan === 'trial')) {
                // Account paid by l'education financiere not affiliation
                const dialogRef = this.dialog.open(LeducationFinanciereComponent, {
                    width: '600px',
                    height: '500px',
                    disableClose: true,
                    data: {},
                });

                dialogRef.afterClosed().subscribe(result => {
                    this.authenticationService.currentUser.user_onboarding.show_pro_popup = false;
                    this.userService.updateOnboarding(this.authenticationService.currentUser);
                });
            } else if (!this.router.url.includes('/app/user/plan') &&
                this.authenticationService.currentUser.code_parrainage === 'POLYGONE' &&
                this.authenticationService.currentUser.user_onboarding.show_pro_popup == true &&
                (this.authenticationService.currentUser.plan === '' || this.authenticationService.currentUser.plan === 'trial')) {
                const dialogRef = this.dialog.open(PolygoneComponent, {
                    width: '600px',
                    height: '500px',
                    disableClose: true,
                    data: {},
                });

                dialogRef.afterClosed().subscribe(result => {
                    this.authenticationService.currentUser.user_onboarding.show_pro_popup = false;
                    this.userService.updateOnboarding(this.authenticationService.currentUser);
                });
            } else if (!this.router.url.includes('/app/user/plan') &&
                this.authenticationService.currentUser.pro_plan === 'purpleimmobilier' &&
                this.authenticationService.currentUser.user_onboarding.show_pro_popup == true) {
                const dialogRef = this.dialog.open(PurpleComponent, {
                    width: '600px',
                    height: '505px',
                    disableClose: true,
                    data: {},
                });

                dialogRef.afterClosed().subscribe(result => {
                    this.authenticationService.currentUser.user_onboarding.show_pro_popup = false;
                    this.authenticationService.currentUser.form = true;

                    this.userService.updateOnboarding(this.authenticationService.currentUser);
                    const dialogRef = this.dialog.open(FormComponent, {
                        width: '860px',
                        maxWidth: '92%',
                        maxHeight: '96vh',
                        disableClose: true,
                        data: {
                            step: 'step8',
                        },
                    });
                    dialogRef.afterClosed().subscribe(result => {
                        this.router.navigate(['/app/search/result']);
                        this.onboardingService.startSearch().subscribe();
                    });
                });
            } else if (this.authenticationService.currentUser.form == false) {
                const dialogRef = this.dialog.open(FormComponent, {
                    width: '860px',
                    maxWidth: '92%',
                    maxHeight: '96vh',
                    disableClose: true,
                    data: {
                        step: 'step1',
                    },
                });

                dialogRef.afterClosed().subscribe(result => {
                    this.authenticationService.currentUser.form = true;
                    this.router.navigate(['/app/search/result']);
                    this.onboardingService.startSearch().subscribe();
                });
            } else if (this.router.url.includes('#inc_trial') && this.authenticationService.currentUser.show_trial_inc == false) {
                this.authenticationService.currentUser.show_trial_inc = true;
                this.userService.increaseOnboarding(this.authenticationService.currentUser).subscribe(result => {
                    this.authenticationService.setUser(result);
                    const dialogRef = this.dialog.open(IncreaseTrialComponent, {
                        width: '480px',
                        maxWidth: '92%',
                        maxHeight: '96vh',
                        disableClose: false,
                        data: {},
                    });
                });
            } else if (this.authenticationService.showPromo() == true && this.authenticationService.currentUser.show_promo == false) {
                this.authenticationService.currentUser.show_promo = true;
                this.userService.hidePromo(this.authenticationService.currentUser).subscribe(result => {
                    this.authenticationService.setUser(result);
                    const dialogRef = this.dialog.open(ShowPromoComponent, {
                        width: '480px',
                        maxWidth: '92%',
                        maxHeight: '96vh',
                        disableClose: false,
                        data: {},
                    });
                    dialogRef.afterClosed().subscribe(result => {
                        if (result === true) {
                            this.router.navigate(['/app/user/plan']);
                        }
                    });
                });
            } else if ((days > 10 || this.router.url.includes('#rate'))
                && this.authenticationService.currentUser.user_onboarding.show_rate == false && this.authenticationService.currentUser.rate_form == false
            ) {
                this.authenticationService.currentUser.user_onboarding.show_rate = true;
                this.userService.updateOnboarding(this.authenticationService.currentUser);

                const dialogRef = this.dialog.open(RateComponent, {
                    width: '640px',
                    maxWidth: '92%',
                    maxHeight: '96vh',
                    disableClose: false,
                    data: {
                        step: (this.router.url.includes('#rate') ? 1 : 0),
                    },
                });

                dialogRef.afterClosed().subscribe(result => {
                    if (result === true) {
                        this.router.navigate(['/app/dashboard/rate']);
                    }
                });
            } else if (days > 7 && this.authenticationService.currentUser.user_onboarding.show_calendly == false) {
                this.authenticationService.currentUser.user_onboarding.show_calendly = true;
                this.userService.updateOnboarding(this.authenticationService.currentUser);

                const dialogRef = this.dialog.open(CalendlyComponent, {
                    width: '640px',
                    maxWidth: '92%',
                    maxHeight: '96vh',
                    disableClose: false,
                    data: {},
                });
            // } else if (this.authenticationService.currentUser.news_form == false && this.deviceService.isDesktop() == true) {
            //     this.userService.closeNewsForm().subscribe(invoices => {
            //         const dialogRef = this.dialog.open(NewsComponent, {
            //             width: '580px',
            //             maxWidth: '92%',
            //             maxHeight: '96vh',
            //             disableClose: false,
            //             autoFocus: false,
            //             data: {},
            //         });
            //
            //         dialogRef.afterClosed().subscribe(result => {
            //             this.authenticationService.currentUser.news_form = true;
            //         });
            //     }, error => {
            //     });
            } else if (this.authenticationService.currentUser.plan == '' && this.authenticationService.currentUser.pro_plan == '' && this.authenticationService.currentUser.popup_endtrial == false) {
                const dialogRef = this.dialog.open(EndtrialComponent, {
                    width: '96%',
                    height: '96vh',
                    maxWidth: '96%',
                    // maxHeight: '80vh',
                    disableClose: true,
                    autoFocus: false,
                });

                dialogRef.afterClosed().subscribe(result => {
                    this.authenticationService.currentUser.news_form = true;
                });
            } else {
                this.http.get<Video>(environment.apiUrl + 'app/video').subscribe(video => {
                    if (video.link) {
                        this.userService.closeVideoForm().subscribe(invoices => {
                            const dialogRef = this.dialog.open(VideoComponent, {
                                width: '580px',
                                maxWidth: '92%',
                                maxHeight: '96vh',
                                disableClose: false,
                                autoFocus: false,
                                data: {video},
                            });
                        }, error => {
                        });
                    }
                });
            }
        }
    }

    openAnnonce() {
        var url = this.router.url;
        var regexpFavorite = new RegExp('^/app/favorites/([a-z0-9-]*)/([a-z0-9-]*)/.*$');
        var regexpAnnonce = new RegExp('^/app/annonces/([a-z0-9-]*)/.*$');

        if (regexpFavorite.test(url) === true) {
            var res = regexpFavorite.exec(url);
            this.onboardingService.startFavoris(res[1], res[2]).subscribe();
        } else if (regexpAnnonce.test(url) === true) {
            var res = regexpAnnonce.exec(url);
            this.onboardingService.startAnnonce(res[1]).subscribe();
        } else {
            this.adService.getFavoritesList('historic/last').subscribe(result => {
                if (result.favorites.length > 0) {
                    if (result.favorites[0].favorite_list.id) {
                        this.onboardingService.startFavoris(result.favorites[0].favorite_list.id, result.favorites[0].id).subscribe();
                    } else {
                        this.onboardingService.startAnnonce(result.favorites[0].id).subscribe();
                    }
                } else {
                    this.onboardingService.showAlert('noAnnoncesStep');
                }
            });
        }
    }

    openPDF() {
        var url = this.router.url;
        var regexpFavorite = new RegExp('^/app/favorites/([a-z0-9-]*)/([a-z0-9-]*)/.*$');

        if (regexpFavorite.test(url) === true) {
            var res = regexpFavorite.exec(url);
            this.onboardingService.startPDF(res[1], res[2]).subscribe();
        } else {
            this.adService.getFavoritesList('historic/lastFav').subscribe(result => {
                if (result.favorites.length > 0) {
                    this.onboardingService.startPDF(result.favorites[0].favorite_list.id, result.favorites[0].id).subscribe();
                } else {
                    this.onboardingService.showAlert('noFavoriteStep');
                }
            });
        }
    }

    closeTopMsg() {
        this.showHeader = false;
        this.authenticationService.currentUser.header_form = true;
        if (this.authenticationService.isLogin) {
            this.userService.closeHeaderForm().subscribe(invoices => {
            }, error => {
            });
        }
    }

    compare() {
        this.adService.getFavoritesList('historic/lastFav').subscribe(result => {
            if (result.favorites.length >= 2) {

                this.adService.getCompareAd().subscribe(r => {
                    if (r.length == 1) {
                        this.adService.addCompareAd(result.favorites[0].id);
                    } else if (r.length == 0) {
                        this.adService.addCompareAd(result.favorites[0].id);
                        this.adService.addCompareAd(result.favorites[1].id);
                    }
                    this.onboardingService.startCompare(result.favorites[0].favorite_list.id).subscribe();
                });

            } else {
                this.onboardingService.showAlert('noFavoriteStep');
            }
        });
    }

    openAlert() {
        var url = this.router.url;
        var regexpSearch = new RegExp('^/app/search/([0-9]*)$');

        if (regexpSearch.test(url) === true) {
            var res = regexpSearch.exec(url);
            this.onboardingService.startAlert(res[1]).subscribe();
        } else {
            this.adService.getUserSearch().subscribe(r => {
                if (r.length > 0) {
                    this.onboardingService.startAlert(r[r.length - 1].id).subscribe();
                } else {
                    this.onboardingService.showAlert('noSearchStep');
                }
            });
        }
    }

    openFavoriteList() {
        var url = this.router.url;
        var regexpFavorite = new RegExp('^/app/favorites/([a-z0-9-]*)$');

        if (regexpFavorite.test(url) === true && url != '/app/favorites/compare') {
            var res = regexpFavorite.exec(url);
            this.onboardingService.startFavoriteList(res[1]).subscribe();
        } else {

            this.adService.getFavoritesList('historic/lastFav').subscribe(result => {
                if (result.favorites.length > 0) {
                    this.onboardingService.startFavoriteList(result.favorites[0].favorite_list.id).subscribe();
                } else {
                    this.onboardingService.showAlert('noFavoriteStep');
                }
            });
        }
    }


    toogleOnboarding() {
        this.authenticationService.currentUser.user_onboarding.open = !this.authenticationService.currentUser.user_onboarding.open;
        this.userService.updateOnboarding(this.authenticationService.currentUser);
    }

    closeOnboarding() {
        this.authenticationService.currentUser.user_onboarding.dismiss = true;
        this.authenticationService.currentUser.user_onboarding.dismiss_date = new Date().toISOString();
        this.userService.updateOnboarding(this.authenticationService.currentUser);
        this.onboardingService.showCompteMenu();
    }
}
